import { useGT } from 'gt-react';
import type {
  WorkbookPivotDateGroup,
  WorkbookPivotShowAs,
  WorkbookPivotSummary,
} from '@erp/shared-types';

/** The pivot editor's names for summaries, show-as choices and date groupings. */
export function usePivotLabels() {
  const gt = useGT();
  const summaries: Record<WorkbookPivotSummary, string> = {
    // Spreadsheet function names: the same in every language.
    sum: 'SUM',
    count: 'COUNT',
    counta: 'COUNTA',
    countunique: 'COUNTUNIQUE',
    average: 'AVERAGE',
    min: 'MIN',
    max: 'MAX',
    median: 'MEDIAN',
  };
  const summaryHints: Record<WorkbookPivotSummary, string> = {
    sum: gt('Total of the numbers', { context: 'pivot summary hint' }),
    count: gt('How many numbers', { context: 'pivot summary hint' }),
    counta: gt('How many non-empty cells', { context: 'pivot summary hint' }),
    countunique: gt('How many different values', {
      context: 'pivot summary hint',
    }),
    average: gt('Mean of the numbers', { context: 'pivot summary hint' }),
    min: gt('Smallest number', { context: 'pivot summary hint' }),
    max: gt('Largest number', { context: 'pivot summary hint' }),
    median: gt('Middle number', { context: 'pivot summary hint' }),
  };
  const showAs: Record<WorkbookPivotShowAs, string> = {
    value: gt('Default', { context: 'pivot value show as' }),
    'percent-of-grand-total': gt('% of grand total', {
      context: 'pivot value show as',
    }),
    'percent-of-row': gt('% of row', { context: 'pivot value show as' }),
    'percent-of-column': gt('% of column', {
      context: 'pivot value show as',
    }),
  };
  const dateGroups: Record<WorkbookPivotDateGroup, string> = {
    year: gt('Year', { context: 'pivot date grouping' }),
    quarter: gt('Quarter', { context: 'pivot date grouping' }),
    month: gt('Month', { context: 'pivot date grouping' }),
    day: gt('Day', { context: 'pivot date grouping' }),
  };
  const areas = {
    rows: gt('Rows', { context: 'pivot editor area' }),
    columns: gt('Columns', { context: 'pivot editor area' }),
    values: gt('Values', { context: 'pivot editor area' }),
    filters: gt('Filters', { context: 'pivot editor area' }),
  };
  return { summaries, summaryHints, showAs, dateGroups, areas };
}
